import { cn } from '../../lib/utils';

/**
 * On/off switch for permission editing.
 *
 * A switch rather than a checkbox because these represent a standing state ("Feed is available
 * to this user") rather than a selection, and because the admin screens show a dozen at once
 * where the on/off read needs to be instant.
 */
export function Toggle({
  checked, onChange, disabled, label, id,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** Accessible name — the visible text usually sits beside the switch, not inside it. */
  label: string;
  id?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      id={id}
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex h-4 w-7 flex-shrink-0 items-center rounded-full transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/50',
        checked ? 'bg-orange-500' : 'bg-border-strong',
        disabled && 'opacity-40 cursor-not-allowed',
      )}
    >
      <span
        className={cn(
          'inline-block h-3 w-3 transform rounded-full bg-white shadow transition-transform',
          checked ? 'translate-x-3.5' : 'translate-x-0.5',
        )}
      />
    </button>
  );
}
